import type { DataTableRenderCellParams } from '@/components/custom/erp/data-table-v2';
import type { TabItem } from '@/components/custom/erp';
import { ChiPhiChiTietTab } from './ChiPhiChiTietTab';
import type { FormDialogModel } from './hooks';
import { DetailTab } from './DetailTab';
import { ChiPhiTab } from './ChiPhiTab';
import { OtherTab } from './OtherTab';
import { ThueTab } from './ThueTab';

const scrollableTab = (content: React.ReactNode) => <div className='h-full overflow-y-auto pb-24'>{content}</div>;

export const FormTabs = (dialog: FormDialogModel): TabItem[] => {
  if (dialog.activeTab !== 'info') return [];

  return [
    {
      id: 'details',
      label: 'Chi tiết',
      component: (
        <DetailTab
          formMode={dialog.formMode}
          rows={dialog.detail.rows}
          selectedRowUuid={dialog.detail.selectedRowUuid}
          onRowClick={dialog.detail.handleRowClick}
          onCellClick={dialog.detail.handleCellClick}
          selectedCell={dialog.detail.selectedCell}
          onAddRow={dialog.detail.handleAddRow}
          onDeleteRow={dialog.detail.handleDeleteRow}
          onCopyRow={dialog.detail.handleCopyRow}
          onPasteRow={dialog.detail.handlePasteRow}
          onMoveRow={dialog.detail.handleMoveRow}
          onAllocateDiscount={dialog.detail.allocateDiscount}
          onCellValueChange={dialog.detail.trackedCellValueChange}
          onRepeatForRows={dialog.detail.repeatRows}
          formState={dialog.formState}
          constraints={dialog.constraints}
          handleUpdateNonWritableFields={dialog.detail.setNonWritableFields}
          handleUpdatePasteConfigs={dialog.detail.setPasteConfigs}
          isPasting={dialog.detail.isPasting}
        />
      )
    },
    {
      id: 'chi_phi',
      label: 'Chi phí',
      component: (
        <ChiPhiTab
          formMode={dialog.formMode}
          rows={dialog.cost.rows}
          selectedRowUuid={dialog.cost.selectedRowUuid}
          selectedCell={dialog.cost.selectedCell}
          onRowClick={dialog.cost.handleRowClick}
          onCellClick={
            dialog.cost.handleCellClick as (params: DataTableRenderCellParams<{ uuid?: string | null }>) => void
          }
          onAddRow={dialog.cost.handleAddRow}
          onDeleteRow={dialog.cost.handleDeleteRow}
          onCopyRow={dialog.cost.handleCopyRow}
          onPasteRow={dialog.cost.handlePasteRow}
          onMoveRow={dialog.cost.handleMoveRow}
          onCellValueChange={dialog.cost.handleCellValueChange}
          handleUpdateNonWritableFields={dialog.cost.setNonWritableFields}
          handleUpdatePasteConfigs={dialog.cost.setPasteConfigs}
          isPasting={dialog.cost.isPasting}
        />
      )
    },
    {
      id: 'chi_phi_chi_tiet',
      label: 'Chi phí chi tiết',
      component: (
        <ChiPhiChiTietTab
          formMode={dialog.formMode}
          rows={dialog.costDetail.rows}
          selectedRowUuid={dialog.costDetail.selectedRowUuid}
          onRowClick={dialog.costDetail.handleRowClick}
          onAddRow={dialog.costDetail.handleAddRow}
          onDeleteRow={dialog.costDetail.handleDeleteRow}
          onCopyRow={dialog.costDetail.handleCopyRow}
          onPasteRow={dialog.costDetail.handlePasteRow}
          onMoveRow={dialog.costDetail.handleMoveRow}
          onCellValueChange={dialog.costDetail.handleCellValueChange}
        />
      )
    },
    {
      id: 'thue',
      label: 'Thuế',
      component: (
        <ThueTab
          formMode={dialog.formMode}
          rows={dialog.tax.rows}
          selectedRowUuid={dialog.tax.selectedRowUuid}
          selectedCell={dialog.tax.selectedCell}
          state={dialog.formState}
          onRowClick={dialog.tax.handleRowClick}
          onCellClick={
            dialog.tax.handleCellClick as (params: DataTableRenderCellParams<{ uuid?: string | null }>) => void
          }
          onAddRow={dialog.tax.handleAddRow}
          onDeleteRow={dialog.tax.handleDeleteRow}
          onCopyRow={dialog.tax.handleCopyRow}
          onPasteRow={dialog.tax.handlePasteRow}
          onMoveRow={dialog.tax.handleMoveRow}
          onCellValueChange={dialog.tax.cellValueChange}
          onCellCommit={dialog.tax.cellCommit}
          handleUpdateNonWritableFields={dialog.tax.setNonWritableFields}
          handleUpdatePasteConfigs={dialog.tax.setPasteConfigs}
          onHandleDetail={dialog.tax.detailFromDetailTab}
          isPasting={dialog.tax.isPasting}
        />
      )
    },
    {
      id: 'other',
      label: 'Khác',
      component: scrollableTab(<OtherTab formMode={dialog.formMode} />)
    }
  ];
};
